import { useBoxLead } from "@modules/boxLead/hooks/useBoxLeadDetails"
import { PublicProfileDetails } from "@modules/profile/publicProfile/components/publicProfileDetails"
import { useUserProfile } from "@modules/profile/publicProfile/hooks/useUserProfile"

type BoxLeadPublicProfilProps = {
  leadId: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadPublicProfil({ leadId, className, ...props }: BoxLeadPublicProfilProps) {
  const { data: leadDetails } = useBoxLead(leadId)
  const { data: publicProfile } = useUserProfile(leadDetails.user?.id ?? "")

  if (!publicProfile) return null
  return <PublicProfileDetails publicProfile={publicProfile} className={className} {...props} />
}
